import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 129 129"
  >
    <g>
      <path
        d="M4.86035 102.787V119.853C4.86035 124.566 8.68078 128.387 13.3936 128.387H115.794C120.506 128.387 124.327 124.566 124.327 119.853V102.787H4.86035Z"
        fill="#B5DBFF"
      />
      <path
        d="M118.403 102.787V119.854C118.403 124.566 114.583 128.387 109.87 128.387H115.794C120.507 128.387 124.327 124.566 124.327 119.854V102.787H118.403Z"
        fill="#97D0FF"
      />
      <path
        d="M4.86035 34.52V111.32C4.86035 116.033 8.68078 119.853 13.3933 119.853H115.794C120.506 119.853 124.327 116.033 124.327 111.32V34.52H4.86035Z"
        fill="#EDF5FF"
      />
      <path
        d="M118.403 34.52V111.32C118.403 116.033 114.583 119.853 109.87 119.853H115.794C120.507 119.853 124.327 116.033 124.327 111.32V34.52H118.403Z"
        fill="#D5E8FE"
      />
      <path
        d="M124.327 38.7867V17.4532C124.327 12.7403 120.506 8.92017 115.794 8.92017H13.3936C8.68076 8.92017 4.8606 12.7406 4.8606 17.4532V38.7867H124.327Z"
        fill="#EE7635"
      />
      <path
        d="M30.4603 19.3852H26.1936C25.1268 19.3852 24.262 18.5203 24.262 17.4536C24.262 16.3868 25.1268 15.522 26.1936 15.522H30.4603C31.5271 15.522 32.3919 16.3868 32.3919 17.4536C32.3919 18.5203 31.5271 19.3852 30.4603 19.3852Z"
        fill="#EE7635"
      />
      <path
        d="M43.2604 19.3852H38.9936C37.9268 19.3852 37.062 18.5203 37.062 17.4536C37.062 16.3868 37.9268 15.522 38.9936 15.522H43.2601C44.3268 15.522 45.1917 16.3868 45.1917 17.4536C45.1917 18.5203 44.3271 19.3852 43.2604 19.3852Z"
        fill="#EE7635"
      />
      <path
        d="M90.1936 19.3852H85.9271C84.8603 19.3852 83.9955 18.5203 83.9955 17.4536C83.9955 16.3868 84.8603 15.522 85.9271 15.522H90.1936C91.2603 15.522 92.1252 16.3868 92.1252 17.4536C92.1252 18.5203 91.2603 19.3852 90.1936 19.3852Z"
        fill="#EE7635"
      />
      <path
        d="M102.994 19.3852H98.7269C97.6601 19.3852 96.7953 18.5203 96.7953 17.4536C96.7953 16.3868 97.6601 15.522 98.7269 15.522H102.994C104.06 15.522 104.925 16.3868 104.925 17.4536C104.925 18.5203 104.06 19.3852 102.994 19.3852Z"
        fill="#EE7635"
      />
      <path
        d="M30.4603 17.4535C30.4603 19.8098 32.3706 21.7202 34.7271 21.7202C37.0836 21.7202 38.9938 19.81 38.9938 17.4535V4.65347C38.9936 2.29693 37.0834 0.386719 34.7268 0.386719C32.3706 0.386719 30.4601 2.29693 30.4601 4.65347L30.4603 17.4535Z"
        fill="#0A67B2"
      />
      <path
        d="M90.1936 17.4535C90.1936 19.8098 92.1038 21.7202 94.4604 21.7202C96.8169 21.7202 98.7271 19.81 98.7271 17.4535V4.65347C98.7271 2.29693 96.8169 0.386719 94.4604 0.386719C92.1038 0.386719 90.1936 2.29693 90.1936 4.65347V17.4535Z"
        fill="#0A67B2"
      />
      <path
        d="M115.794 8.91992H109.87C114.583 8.91992 118.403 12.7403 118.403 17.4529V38.7867H124.327V17.4532C124.327 12.7403 120.506 8.91992 115.794 8.91992Z"
        fill="#EE7635"
      />
      <path
        d="M4.86035 28.3218H124.327V32.185H4.86035V28.3218Z"
        fill="#EE7635"
      />
      <path
        d="M66.7268 67.5867C66.7268 58.7642 59.5493 51.5867 50.7268 51.5867C41.9043 51.5867 34.7268 58.7642 34.7268 67.5867C34.7268 69.9432 36.637 71.8534 38.9936 71.8534C41.3501 71.8534 43.2603 69.9432 43.2603 67.5867C43.2603 63.4695 46.6097 60.1199 50.7271 60.1199C54.8442 60.1199 58.1938 63.4693 58.1938 67.5867C58.1938 71.704 54.8444 75.0534 50.7271 75.0534C48.3705 75.0534 46.4603 76.9636 46.4603 79.3202C46.4603 81.6767 48.3705 83.5869 50.7271 83.5869C54.8442 83.5869 58.1938 86.9363 58.1938 91.0537C58.1938 95.1708 54.8444 98.5204 50.7271 98.5204C46.6099 98.5204 43.2603 95.1711 43.2603 91.0537C43.2603 88.6971 41.3501 86.7869 38.9936 86.7869C36.637 86.7869 34.7268 88.6971 34.7268 91.0537C34.7268 99.8761 41.9043 107.054 50.7268 107.054C59.5493 107.054 66.7268 99.8761 66.7268 91.0537C66.7268 86.4215 64.746 82.2449 61.5895 79.3204C64.7463 76.3955 66.7268 72.2189 66.7268 67.5867Z"
        fill="#0A67B2"
      />
      <path
        d="M87.2264 51.9115C85.6319 51.2506 83.7967 51.6163 82.5767 52.8366L74.0434 61.3698C72.3771 63.0359 72.3771 65.7375 74.0434 67.4036C75.7095 69.0697 78.4112 69.0697 80.0772 67.4036L81.3271 66.1537V102.787C81.3271 105.143 83.2373 107.053 85.5938 107.053C87.9504 107.053 89.8606 105.143 89.8606 102.787V55.8535C89.8603 54.1277 88.8206 52.5718 87.2264 51.9115Z"
        fill="#0A67B2"
      />
    </g>
    <defs>
      <clipPath id="clip0_427_5">
        <rect
          width="128"
          height="128"
          fill="white"
          transform="translate(0.593628 0.386719)"
        />
      </clipPath>
    </defs>
  </svg>,
  "Calendar"
);
